export const BUSINESS_CARD_DEFAULT_WIDTH = 384;
export const BUSINESS_CARD_DEFAULT_HEIGHT = 216;
export const BUSINESS_CARD_DEFAULT_MIN_WIDTH = 256;
export const BUSINESS_CARD_DEFAULT_MIN_HEIGHT = 144;
export const MAX_DEGREE = 5;
